import React from "react";
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import Session from '../shared/Session';
import { titleCase } from '../shared/Utilities';

export default class Viewer extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: []
        };
        this.reloadData();
    };

    reloadData() {
        Session.api("GET", window.location.pathname, {}, (result: any) => {
            this.setState({
                data: result
            });
        });
    };

    render() {
        return (
            <>
                <Typography variant="h4" align="left" gutterBottom component="h2">
                    {titleCase(window.location.pathname.replaceAll("/", " "))}
                </Typography>
                <pre>{Object.keys(this.state.data).length === 0 ? <CircularProgress /> : JSON.stringify(this.state.data, undefined, 4)}</pre>
            </>
        );
    };
};
